import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { PistaService, IRicercaPistaParams } from '@app/shared/services/pista.service';

@Component({
  selector: 'ser-pista-select',
  templateUrl: './pista-select.component.html',
  styleUrl: './pista-select.component.scss'
})
export class PistaSelectComponent {

  @Input() set idStazione(newValue: string) {
    this._idStazione = newValue;
    if (this._idStazione) {
      this.pistaService.idPath = this._idStazione;
      this.loadItems();
    }
  }

  @Input() control: UntypedFormControl;
  @Input() readonly: boolean;
  @Input() label: string = 'piste.title.dettaglio';

  piste: IS1InputSelectItem[];

  _idStazione: string;

  constructor(private pistaService: PistaService) { }

  ngOnInit(): void { 
    this.loadItems();
  }

  loadItems() {

    if (this._idStazione == null) {
      return
    }

    const params: IRicercaPistaParams = {
      page: 1,
      pageSize: 999,
      idStazione: this._idStazione,
      sortBy: "codice ascending"
    }
  
    this.pistaService.ricerca(params).subscribe(pistePaginate => {
  
      this.piste = pistePaginate?.elements?.map(pista => { 
        return { code: pista.id, label: pista.codice + " - " + pista.descrizione?.trim() }  
      }) ?? [];
  
      if (this.piste?.length == 1) {
        this.control?.patchValue(this.piste[0].code);
      }
  
    })

  }

}
